import { EnvironmentTheme } from '@app_services/appconfigservice';

export type Locations = {
  brand: EnvironmentTheme;
  logo_location: string;
  bg_color: string;
  primary_color: string;
  secondary_color: string;
  header_text_color: string;
  hostname: string[];
  favicon: string;
  sitePrimary: Record<number | string, string>;
};

export const ASSETS: Locations[] = [
  {
    brand: 'YAXXA',
    hostname: ['yaxxa.stage.backspace.net.za', 'connect.yaxxa.co.za'],
    logo_location: 'assets/images/yaxxa_logo.png',
    bg_color: '#ffffff',
    primary_color: '#c21b83',
    secondary_color: '#c21b83',
    header_text_color: '#c21b83',
    favicon: 'assets/images/yaxxa_logo.png',
    sitePrimary: {
      50: '#fdeaf5',
      100: '#f9c2e1',
      200: '#f499cc',
      300: '#f070b8',
      400: '#eb47a3',
      500: '#c21b83',
      600: '#9a1667',
      700: '#73104b',
      800: '#4c0b30',
      900: '#250515',
      950: '#12020a',
    },
  },
  {
    brand: 'BACKSPACE',
    hostname: ['backspace.stage.backspace.net.za', 'connect.backspace.co.za'],
    logo_location: 'assets/images/web_logo_bs.png',
    bg_color: '#0a1f3c',
    primary_color: '#01aaf9',
    secondary_color: '#434343',
    header_text_color: '#fff',
    favicon: 'assets/images/favicon.png',
    sitePrimary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
  {
    brand: 'LANLINE',
    hostname: ['lanline.stage.backspace.net.za', 'connect.lanline.co.za'],
    logo_location: 'assets/images/lanline_white.png',
    bg_color: '#37b7f4',
    primary_color: '#37b7f4',
    secondary_color: '#37b7f4',
    header_text_color: '#fff',
    favicon: 'assets/images/lanline-favicon.png',
    sitePrimary: {
      50: '#e6f7ff',
      100: '#b3e5ff',
      200: '#80d3ff',
      300: '#4dc1ff',
      400: '#1aafff',
      500: '#37b7f4',
      600: '#0090cc',
      700: '#0075a3',
      800: '#00597a',
      900: '#003d52',
      950: '#002837',
    },
  },
  {
    brand: 'KLIK',
    hostname: [
      'klik.stage.backspace.net.za',
      'portal.klikpbx.com',
      'connect.klik.global',
    ],
    logo_location: 'assets/images/klikpbx_logo.webp',
    bg_color: '#000000',
    primary_color: '#ff00bd',
    secondary_color: '#ff00bd',
    header_text_color: '#ff00bd',
    favicon: 'assets/images/klik-favicon.png',
    sitePrimary: {
      50: '#ffe6f7',
      100: '#ffb3e5',
      200: '#ff80d3',
      300: '#ff4dc1',
      400: '#ff1aae',
      500: '#ff00bd',
      600: '#cc0096',
      700: '#990070',
      800: '#66004a',
      900: '#330024',
      950: '#1a0012',
    },
  },
  {
    brand: 'STCLOUD',
    hostname: ['st-cloud.stage.backspace.net.za', 'portal.st-cloud.co.za'],
    logo_location: 'assets/images/ST_logo.png',
    bg_color: '#2C3D5A',
    primary_color: '#ce3539',
    secondary_color: '#ce3539',
    header_text_color: '#fff',
    favicon: 'assets/images/STfavicon.png',
    sitePrimary: {
      50: '#fdeaea',
      100: '#f9bcbc',
      200: '#f48e8e',
      300: '#f06060',
      400: '#eb3232',
      500: '#ce3539',
      600: '#a22929',
      700: '#751c1c',
      800: '#490f0f',
      900: '#1d0303',
      950: '#0f0101',
    },
  },
  {
    brand: 'REDEFINEIT',
    hostname: [
      'redefineit.stage.backspace.net.za',
      'portal.redefineit.co.za',
      'connect.redefineit.co.za',
    ],
    logo_location: 'assets/images/RedefineIT_full.png',
    bg_color: '#d3d3d3',
    primary_color: '#C21807',
    secondary_color: '#C21807',
    header_text_color: '#334155',
    favicon: 'assets/images/RedefineIT_icon.png',
    sitePrimary: {
      50: '#fde8e6',
      100: '#fab6b3',
      200: '#f78580',
      300: '#f4534d',
      400: '#f1211a',
      500: '#C21807',
      600: '#9a1306',
      700: '#730e04',
      800: '#4c0903',
      900: '#250502',
      950: '#120301',
    },
  },
  {
    brand: 'MTN',
    hostname: ['mtn.stage.backspace.net.za'],
    logo_location: 'assets/images/mtn_logo.svg',
    bg_color: '#ffcc00',
    primary_color: '#000',
    secondary_color: '#fff',
    header_text_color: '#334155',
    favicon:
      'https://onlinecms.mtn.co.za/sites/default/files/design-system%2C%20vivid%2C%20images%2C%20icons/brand/mtn_logo_lg-sunshine.svg',
    sitePrimary: {
      50: '#fff9e6',
      100: '#fff1b3',
      200: '#ffe880',
      300: '#ffdf4d',
      400: '#ffd61a',
      500: '#ffcc00',
      600: '#e6b800',
      700: '#cc9900',
      800: '#b37a00',
      900: '#805200',
      950: '#664000',
    },
  },
  {
    brand: 'CXP',
    hostname: ['cxp.stage.backspace.net.za'],
    logo_location: 'assets/images/web_logo_bs.png',
    bg_color: '#0a1f3c',
    primary_color: '#01aaf9',
    secondary_color: '#434343',
    header_text_color: '#fff',
    favicon: 'assets/images/favicon.png',
    sitePrimary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
];

// export const PRODASSETS: Locations[] = [
//   {
//     brand: 'YAXXA',
//     hostname: ['connect.yaxxa.co.za'],
//     logo_location: 'assets/images/yaxxa_logo.png',
//     bg_color: '#ffffff',
//     primary_color: '#c21b83',
//     secondary_color: '#c21b83',
//     header_text_color: '#c21b83',
//     favicon: 'assets/images/yaxxa_logo.png',
//     sitePrimary: {
//       50: '#fdeaf5',
//       100: '#f9c2e1',
//       200: '#f499cc',
//       300: '#f070b8',
//       400: '#eb47a3',
//       500: '#c21b83',
//       600: '#9a1667',
//       700: '#73104b',
//       800: '#4c0b30',
//       900: '#250515',
//       950: '#12020a',
//     },
//   },
//   {
//     brand: 'BACKSPACE',
//     hostname: ['connect.backspace.co.za'],
//     logo_location: 'assets/images/web_logo_bs.png',
//     bg_color: '#0a1f3c',
//     primary_color: '#01aaf9',
//     secondary_color: '#434343',
//     header_text_color: '#fff',
//     favicon: 'assets/images/favicon.png',
//     sitePrimary: {
//       50: '{blue.50}',
//       100: '{blue.100}',
//       200: '{blue.200}',
//       300: '{blue.300}',
//       400: '{blue.400}',
//       500: '{blue.500}',
//       600: '{blue.600}',
//       700: '{blue.700}',
//       800: '{blue.800}',
//       900: '{blue.900}',
//       950: '{blue.950}',
//     },
//   },
//   {
//     brand: 'LANLINE',
//     hostname: ['connect.lanline.co.za'],
//     logo_location: 'assets/images/lanline_white.png',
//     bg_color: '#37b7f4',
//     primary_color: '#37b7f4',
//     secondary_color: '#37b7f4',
//     header_text_color: '#fff',
//     favicon: 'assets/images/lanline-favicon.png',
//     sitePrimary: {
//       50: '#e6f7ff',
//       100: '#b3e5ff',
//       200: '#80d3ff',
//       300: '#4dc1ff',
//       400: '#1aafff',
//       500: '#37b7f4',
//       600: '#0090cc',
//       700: '#0075a3',
//       800: '#00597a',
//       900: '#003d52',
//       950: '#002837',
//     },
//   },
//   {
//     brand: 'KLIK',
//     hostname:[ 'klik.stage.backspace.net.za'],
//     logo_location: 'assets/images/klikpbx_logo.webp',
//     bg_color: '#000000',
//     primary_color: '#ff00bd',
//     secondary_color: '#ff00bd',
//     header_text_color: '#ff00bd',
//     favicon: 'assets/images/klik-favicon.png',
//     sitePrimary: {
//       50: '#ffe6f7',
//       100: '#ffb3e5',
//       200: '#ff80d3',
//       300: '#ff4dc1',
//       400: '#ff1aae',
//       500: '#ff00bd',
//       600: '#cc0096',
//       700: '#990070',
//       800: '#66004a',
//       900: '#330024',
//       950: '#1a0012',
//     },
//   },
//   {
//     brand: 'STCLOUD',
//     hostname: ['portal.st-cloud.co.za'],
//     logo_location: 'assets/images/ST_logo.png',
//     bg_color: '#2C3D5A',
//     primary_color: '#ce3539',
//     secondary_color: '#ce3539',
//     header_text_color: '#fff',
//     favicon: 'assets/images/STfavicon.png',
//     sitePrimary: {
//       50: '#fdeaea',
//       100: '#f9bcbc',
//       200: '#f48e8e',
//       300: '#f06060',
//       400: '#eb3232',
//       500: '#ce3539',
//       600: '#a22929',
//       700: '#751c1c',
//       800: '#490f0f',
//       900: '#1d0303',
//       950: '#0f0101',
//     },
//   },
//   {
//     brand: 'redefineit',
//     hostname:[ 'portal.redefineit.co.za'],
//     logo_location: 'assets/images/RedefineIT_full.png',
//     bg_color: '#d3d3d3',
//     primary_color: '#C21807',
//     secondary_color: '#C21807',
//     header_text_color: '#334155',
//     favicon: 'assets/images/RedefineIT_icon.png',
//     sitePrimary: {
//       50: '#fde8e6',
//       100: '#fab6b3',
//       200: '#f78580',
//       300: '#f4534d',
//       400: '#f1211a',
//       500: '#C21807',
//       600: '#9a1306',
//       700: '#730e04',
//       800: '#4c0903',
//       900: '#250502',
//       950: '#120301',
//     },
//   },
//   {
//     brand: 'MTN',
//     hostname:[ 'mtn.stage.backspace.net.za'],
//     logo_location: 'assets/images/mtn_logo.svg',
//     bg_color: '#ffcc00',
//     primary_color: '#000',
//     secondary_color: '#fff',
//     header_text_color: '#334155',
//     favicon:
//       'https://onlinecms.mtn.co.za/sites/default/files/design-system%2C%20vivid%2C%20images%2C%20icons/brand/mtn_logo_lg-sunshine.svg',
//     sitePrimary: {
//       50: '#fff9e6',
//       100: '#fff1b3',
//       200: '#ffe880',
//       300: '#ffdf4d',
//       400: '#ffd61a',
//       500: '#ffcc00',
//       600: '#e6b800',
//       700: '#cc9900',
//       800: '#b37a00',
//       900: '#805200',
//       950: '#664000',
//     },
//   },
// ];

// function changeColor(colorCode: string) {
//   document.documentElement.style.setProperty(
//     '--white-label-primary-color',
//     colorCode,
//   );
// }

// export function getWhiteLabelAssets() {
//   if (!window) throw new Error('Invalid environment');
//   if (!window.location) throw new Error('Invalid environment');

//   const hostname = window.location.host.toLowerCase();

//   const selectedTheme =
//     ASSETS.find(asset => asset.hostname === hostname) ||
//     ASSETS.find(asset => asset.brand === 'BACKSPACE');

//   changeColor(selectedTheme!.primary_color);

//   return selectedTheme;
// }
